import { render } from "./UploadRow.vue?vue&type=template&id=5012f258&ts=true"
import script from "./UploadRow.vue?vue&type=script&lang=ts"
export * from "./UploadRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__